import { styled } from "@mui/material"

export const PdfLink = styled("a")(({ theme }) => ({
    display: "block",
    fontSize: "0",
    color: theme.palette.grey[700],
}))
